export const INIT_STATE = 'INIT_STATE';
export const CACHE_VALUES = 'CACHE_VALUES';
export const RESULT = 'RESULT';